import React from "react";

import LineStyleIcon from "@mui/icons-material/LineStyle";

function ParameterMapIcon({ iconColor, iconSize = "small", ...other }) {
    return <LineStyleIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default ParameterMapIcon;
